import styled from 'styled-components'
import { Typography } from '@material-ui/core'

const BestParamsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

const Param = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`

interface BestParamsProps {
  chunckSize: number
  waveOffset?: number
  movingAverageIndex?: number
}

export default ({
  chunckSize,
  waveOffset,
  movingAverageIndex,
}: BestParamsProps) => (
  <BestParamsContainer>
    <Param>
      <Typography variant='caption' style={{ marginRight: 2 }}>
        CS:
      </Typography>
      <Typography variant='caption'>{chunckSize}</Typography>
    </Param>
    <Param>
      <Typography variant='caption' style={{ marginRight: 2 }}>
        WO:
      </Typography>
      <Typography variant='caption'>{waveOffset}</Typography>
    </Param>
    <Param>
      <Typography variant='caption' style={{ marginRight: 2 }}>
        MAI:
      </Typography>
      <Typography variant='caption'>{movingAverageIndex}</Typography>
    </Param>
  </BestParamsContainer>
)
